// extracted by mini-css-extract-plugin
export default {"SubmitButton":"Forms_SubmitButton__jNeSa"};